var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.2408 5.33968 21.5847 10.3594 22.3724V15.0352H7.69336V12H10.3594V9.68672C10.3594 7.05516 11.927 5.60156 14.3254 5.60156C15.4742 5.60156 16.6758 5.80664 16.6758 5.80664V8.39062H15.3518C14.0475 8.39062 13.6406 9.20007 13.6406 10.0304V12H16.5527L16.0872 15.0352H13.6406V22.3724C18.6603 21.5847 22.5 17.2408 22.5 12Z",
    fill: "#045694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0872 15.0352L16.5527 12H13.6406V10.0304C13.6406 9.20007 14.0475 8.39062 15.3518 8.39062H16.6758V5.80664C16.6758 5.80664 15.4742 5.60156 14.3254 5.60156C11.927 5.60156 10.3594 7.05516 10.3594 9.68672V12H7.69336V15.0352H10.3594V22.3724C10.894 22.4563 11.4418 22.5 12 22.5C12.5582 22.5 13.106 22.4563 13.6406 22.3724V15.0352H16.0872Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhFacebook);
export default __webpack_public_path__ + "static/media/fmh-facebook.0fbf1220c8506f82c8007f7343c8b99e.svg";
export { ForwardRef as ReactComponent };